import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import ClientsTable from "./ClientsTable";
import SelectedClient from "./SelectedClient";

const Clients = (props) => {
  const [clients, setClients] = useState(props.clients);
  const [selectedClient, setSelectedClient] = useState(props.clients[0]);

  useEffect(() => {
    if (!selectedClient) return;

    setSelectedClient(
      clients.find((client) => client.id === selectedClient.id),
    );
  }, [clients]);

  return (
    <div className="flex flex-start gap-24">
      <ClientsTable
        clients={clients}
        setClients={setClients}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
      />

      <SelectedClient
        clients={clients}
        setClients={setClients}
        selectedClient={selectedClient}
        allCourses={props.all_courses}
      />
    </div>
  );
};

Clients.propTypes = {
  clients: PropTypes.array,
  all_courses: PropTypes.array,
};

export default Clients;
